var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.85 26.4668C17.85 27.1019 18.3649 27.6168 19 27.6168C19.6351 27.6168 20.15 27.1019 20.15 26.4668L17.85 26.4668ZM19.8132 9.7204C19.3641 9.2713 18.6359 9.2713 18.1868 9.7204L10.8683 17.039C10.4192 17.4881 10.4192 18.2162 10.8683 18.6653C11.3174 19.1144 12.0455 19.1144 12.4946 18.6653L19 12.1599L25.5054 18.6653C25.9545 19.1144 26.6826 19.1144 27.1317 18.6653C27.5808 18.2162 27.5808 17.4881 27.1317 17.039L19.8132 9.7204ZM20.15 26.4668L20.15 10.5336L17.85 10.5336L17.85 26.4668L20.15 26.4668Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.6e6f2934.svg";
export { ForwardRef as ReactComponent };